import {
    ClientUpdateHandler, ClientUpdateHandlerRegistry, ClientUpdateRequestType, Collection, StringUtil
} from "@mcleod/core";
import { LayoutCacheAccessor } from "./LayoutCacheAccessor";

/**
 * This class performs the actions necessary to allow the current tab to clear its layout cache.
 */
export class LayoutCacheClearHandler extends ClientUpdateHandler {
    override get type(): ClientUpdateRequestType {
        return ClientUpdateRequestType.CLEAR_LAYOUT_CACHE;
    }

    override handle(addlInputs?: Collection<any>) {
        const singleLayoutToClear = addlInputs?.layoutPath;
        if (StringUtil.isEmptyString(singleLayoutToClear)) {
            LayoutCacheAccessor.clearAll();
        } else {
            LayoutCacheAccessor.clear(singleLayoutToClear);
        }
    }
}
ClientUpdateHandlerRegistry.get().register(new LayoutCacheClearHandler());
